import { render, staticRenderFns } from "./CsTarifariosForm.vue?vue&type=template&id=1dc45b8c"
import script from "./CsTarifariosForm.vue?vue&type=script&lang=js"
export * from "./CsTarifariosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports